import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { CourseComparisonHomeComponent } from './course-comparison-home/course-comparison-home.component'
import { FaqsNewComponent } from './faqs-new/faqs-new.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '../pages/pipe.module'
import { MatButtonModule } from '@angular/material/button';
import { ToppersMeetComponent } from './toppers-meet/toppers-meet.component';
import { MatDialogModule } from '@angular/material/dialog';
import { IquantaFeaturesComponent } from './iquanta-features/iquanta-features.component';
import { StudentCarouselComponent } from './student-carousel/student-carousel.component';
import { FounderHomeComponent } from './founder-home/founder-home.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CatCoursePackageMocksComponent, LeadFormDialog } from './cat-course-package/cat-course-package-mocks.component'
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConstantService } from 'src/providers/constants';
import { BSchoolService } from 'src/providers/b-schools.service';
import { JSONIDService } from 'src/providers/schema';
import { HomeJSONIDService } from 'src/providers/home-schema';
import { CountdownModule } from 'ngx-countdown';

import { CompassComponent } from '../compass/compass.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatSelectModule,
    MatBottomSheetModule,
    NgxSliderModule,
    MatTooltipModule,
    NgOptimizedImage,
    CountdownModule,
    MatMenuModule


  ],

  declarations: [
    StudentCarouselComponent,
    FounderHomeComponent,
    ThanksDialogueComponent,
    CourseComparisonHomeComponent,
    FaqsNewComponent,
    CompassComponent,
    ToppersMeetComponent,
    IquantaFeaturesComponent,
    CatCoursePackageMocksComponent,
    LeadFormDialog,
  ],

  exports: [
    StudentCarouselComponent,
    FounderHomeComponent,
    ThanksDialogueComponent,
    CourseComparisonHomeComponent,
    FaqsNewComponent,
    CompassComponent,
    PipeModule,
    ToppersMeetComponent,
    IquantaFeaturesComponent,
    CatCoursePackageMocksComponent,
    LeadFormDialog,
  ],
  providers: [
    DatePipe,
    ConstantService,
    BSchoolService, JSONIDService, HomeJSONIDService,
  ]

})
export class ChildComponentsModule { }
